const state = {
    status: '',
    theme: '',
    auth: {
        message: undefined,
        prerequisites: [],
        needPrerequisite: [],
        userInfo: {},
        userResource: {},
        serviceGroups: [],
        from: null
    },
    board: {
        boardDocuments: [],
        boardDocument: null
    },
    profile: {
        logHistory: [],
        userInfo: {}
    },
    document: {
        agreementDocument: null,
        privacyDocument: null
    }
}

export default state
